/* Система уведомлений для отображения всплывающих сообщений */

class NotificationManager {
  constructor() {
    this.containerId = 'notification-container';
    this.createContainer();
    this.autoHideDelay = 5000; // 5 секунд
  }

  // Создание контейнера для уведомлений
  createContainer() {
    if (document.getElementById(this.containerId)) return;

    const container = document.createElement('div');
    container.id = this.containerId;
    container.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 400px;
    `;

    document.body.appendChild(container);
  }

  // Показать уведомление
  show(message, type = 'info', title = null, autoHide = true) {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;

    const icon = this.getIcon(type);
    const color = this.getColor(type);

    notification.style.cssText = `
      padding: 16px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      border-left: 4px solid ${color};
      display: flex;
      align-items: flex-start;
      gap: 12px;
      animation: slideIn 0.3s ease-out;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      max-width: 400px;
    `;

    notification.innerHTML = `
      <div style="font-size: 20px; color: ${color}; flex-shrink: 0;">${icon}</div>
      <div style="flex: 1;">
        ${title ? `<div style="font-weight: 600; font-size: 14px; color: #333; margin-bottom: 4px;">${title}</div>` : ''}
        <div style="font-size: 14px; color: #666; line-height: 1.4;">${message}</div>
      </div>
      <button class="close-btn" style="
        background: none;
        border: none;
        font-size: 18px;
        color: #999;
        cursor: pointer;
        padding: 0;
        margin: -4px -4px 0 0;
        line-height: 1;
      ">×</button>
    `;

    // Закрытие по клику
    const closeBtn = notification.querySelector('.close-btn');
    closeBtn.addEventListener('click', () => this.removeNotification(notification));

    // Автоматическое скрытие
    if (autoHide) {
      setTimeout(() => this.removeNotification(notification), this.autoHideDelay);
    }

    // Добавляем в контейнер
    document.getElementById(this.containerId).appendChild(notification);

    // Добавляем стили для анимации, если их еще нет
    this.addStyles();

    return notification;
  }

  // Удалить уведомление
  removeNotification(notification) {
    notification.style.animation = 'slideOut 0.3s ease-out';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 100);
  }

  // Иконки для разных типов уведомлений
  getIcon(type) {
    const icons = {
      success: '✓',
      error: '✕',
      warning: '⚠',
      info: 'ⓘ'
    };
    return icons[type] || icons.info;
  }

  // Цвета для разных типов
  getColor(type) {
    const colors = {
      success: '#10b981',
      error: '#ef4444',
      warning: '#f59e0b',
      info: '#3b82f6'
    };
    return colors[type] || colors.info;
  }

  // Добавление CSS стилей
  addStyles() {
    if (document.getElementById('notification-styles')) return;

    const style = document.createElement('style');
    style.id = 'notification-styles';
    style.textContent = `
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
      
      .notification {
        transition: transform 0.3s, opacity 0.3s;
      }
      
      .close-btn:hover {
        color: #666 !important;
      }
    `;

    document.head.appendChild(style);
  }

  // Методы для разных типов уведомлений
  success(message, title = 'Успешно') {
    return this.show(message, 'success', title);
  }

  error(message, title = 'Ошибка') {
    return this.show(message, 'error', title); // Ошибки не скрываем автоматически
  }

  warning(message, title = 'Внимание') {
    return this.show(message, 'warning', title);
  }

  info(message, title = 'Информация') {
    return this.show(message, 'info', title);
  }
}

// Создаем глобальный экземпляр
const notification = new NotificationManager();

export default notification;